<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, Select, Input } from '@Shelly/shelly-design-system';
	//Helpers
	import { getNumberInputConfig } from 'src/helpers/number_input_helpers';
	import { getErrorOrInfoMessageForMinAndMaxUnit } from 'src/helpers/utilities';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions['virtual'];

	let virtualControlOption: LocalControlOptions = controlOption.selected;
	if (/^(boolean)/.test(virtualControlOption.value)) {
		controlOption.selected.params.value = true;
	}

	$: minMaxInfo = getErrorOrInfoMessageForMinAndMaxUnit(
		virtualControlOption.params.value,
		virtualControlOption.config.min,
		virtualControlOption.config.max,
		virtualControlOption.unit,
	);
</script>

<div>
	<Text class="mb-s" element="h2">
		{$format('text_irrigation_controller_zone_label', {
			default: 'Zone:',
		})}
	</Text>
	<Select
		size="m"
		value={virtualControlOption}
		options={controlOption.options}
		icon={!/^number/.test(virtualControlOption.value) ? virtualControlOption.icon : null}
		on:change={(e) => {
			//@ts-ignore
			virtualControlOption = e.detail;
			controlOption.selected = virtualControlOption;
			if (/^(boolean)/.test(virtualControlOption.value)) {
				controlOption.selected.params.value = true;
			}
		}}
		id="select-o54kqlg"
		aria-label={$format('text_irrigation_controller_zone_label', {
			default: 'Zone',
		})}
	/>
</div>

<div>
	{#if virtualControlOption.enums}
		{#if virtualControlOption.value.startsWith('boolean.set')}
			<!-- <Radio
			class="d-inline-flex text-capitalize"
			value="true"
			selected={String(virtualControlOption.params.value)}
			on:click={() => (virtualControlOption.params.value = true)}
			size="m">{capFirstChar($format('on_action', { default: 'on' }))}</Radio
		>
		<Radio
			class="d-inline-flex"
			value="false"
			selected={String(virtualControlOption.params.value)}
			on:click={() => (virtualControlOption.params.value = false)}
			size="m">{capFirstChar($format('off_action', { default: 'off' }))}</Radio
		> -->
		{:else}
			<Text class="mb-s" element="h2">
				{$format('action_change_value', {
					default: 'Action value',
				})}:
			</Text>
			<Select
				size="m"
				value={virtualControlOption.enums.find(
					(i) =>
						i.value ==
						(/^(button)/.test(virtualControlOption.value)
							? virtualControlOption.params.event
							: virtualControlOption.params.value),
				) || virtualControlOption.enums[0]}
				options={virtualControlOption.enums}
				icon={virtualControlOption.icon || 'fa fa-pen'}
				tabIndex="-1"
				on:change={(e) => {
					if (/^(button)/.test(virtualControlOption.value)) {
						virtualControlOption.params.event = e.detail['value'];
					} else {
						virtualControlOption.params.value = e.detail['value'];
					}
				}}
				id="select-tfu93ln"
				aria-label={$format('action_change_value', {
					default: 'Action value',
				})}
			/>
		{/if}
	{:else}
		<Text class="mb-s" element="h2">
			{$format('local_action_component_value', {
				default: 'Component Value:',
			})}
		</Text>
		<Input
			size="m"
			value={virtualControlOption.params.value}
			label={$format('action_change_value', {
				default: 'Action value',
			})}
			{.../^number/.test(virtualControlOption.value) ? { ...getNumberInputConfig() } : {}}
			icon={virtualControlOption.icon ||
				(/^(number)/.test(virtualControlOption.value) ? 'fa fa-calculator' : 'fa fa-pen')}
			tabIndex="-1"
			info={minMaxInfo.info}
			error={minMaxInfo.error}
			on:input={(e) => {
				virtualControlOption.params.value = e.target['value'];
			}}
			id="input-235v5ph"
			aria-labelledby="input-235v5ph"
		/>
	{/if}
</div>
